import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  List,
  ListItem,
  ListItemText,
  Divider,
} from "@mui/material";
import "./AdminDashboard.css";

const AdminDashboard2 = () => {
  const [selectedTab, setSelectedTab] = useState("Project Access");

  const tabs = ["Project Access", "User Management"];

  return (
    <Box className="dashboard-container">
      {/* Left Sidebar */}
      <Box className="admin-sidebar sticky-sidebar">
        {tabs.map((tab) => (
          <Button
            key={tab}
            className={`tab-button ${selectedTab === tab ? "active" : ""}`}
            onClick={() => setSelectedTab(tab)}
            fullWidth
            sx={{ padding: "1vmin 0" }}
          >
            <Typography className="tab-text">{tab}</Typography>
          </Button>
        ))}
      </Box>

      {/* Right Content */}
      <Box className="content responsive-layout">
        {selectedTab === "Project Access" && <ProjectAccess />}
        {selectedTab === "User Management" && <UserManagement />}
      </Box>
    </Box>
  );
};

const ProjectAccess = () => (
  <Box className="section-container">
    <ProjectSection1
      title="Assigned Projects to Users"
      searchPlaceholder="Search User"
    />
    <ProjectSection2
      title="Projects Assigned to Users"
      searchPlaceholder="Search Project"
    />
  </Box>
);

const ProjectSection1 = ({ title, searchPlaceholder }) => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [assignedProjects, setAssignedProjects] = useState([
    "Project A",
    "Project B",
  ]);

  const [isAssigning, setIsAssigning] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [showUserProjects, setShowUsersProjects] = useState(false);
  const allUsers = [
    "sidhantnahak2@gmail.com",
    "rakeshnahak@gmail.com",
    "laxminahak@gmail.com",
  ];
  // const allUsers = ["User 1", "User 2", "User 3"];
  const allProjects = ["Project C", "Project D", "Project E"];
  const [UserProjects, setUserProjects] = useState(["Project A", "Project B"]);

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    setSearchValue("");
  };

  const handleProjectSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setFilteredProjects(
      allProjects.filter((proj) =>
        proj.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleUserProjectSearch = (e) => {
    const value = e.target.value;
    setUserProjects(
      UserProjects.filter((proj) =>
        proj.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  return (
    <Box className="access-section">
      <Typography variant="h7" fontWeight={"bold"} className="section-title">
        {title}
      </Typography>
      <TextField
        label={searchPlaceholder}
        variant="filled"
        size="small"
        fullWidth
        className="search-input"
        value={searchValue}
        onChange={handleProjectSearch}
        onFocus={() => setShowUsers(true)}
        onBlur={() => setTimeout(() => setShowUsers(false), 200)}
        sx={{ my: 1 }}
      />

      {showUsers && (
        <List className="user-list">
          {allUsers.map((item, index) => (
            <ListItem button key={index} onClick={() => handleUserSelect(item)}>
              <Box>
                {/* Primary text styling */}
                <ListItemText
                  primary={item}
                  primaryTypographyProps={{
                    sx: { fontWeight: "bold", fontSize: "2vmin" },
                  }}
                />

                {/* Secondary text styling */}
                <ListItemText
                  secondary={`Assigned Projects: ${assignedProjects.length}`}
                  secondaryTypographyProps={{
                    sx: { fontWeight: "bold", fontSize: "1.5vmin" }, // Adjust size as needed
                  }}
                />
              </Box>
            </ListItem>
          ))}
        </List>
      )}
      {selectedUser && !showUsers && (
        <>
          {/* Selected User */}
          <Typography
            variant="h7"
            sx={{ mt: 2, fontWeight: "bold", color: "primary.main" }}
          >
            {selectedUser}
          </Typography>

          {/* Number of Projects Assigned */}
          <Typography
            variant="body2"
            sx={{ fontWeight: "bold", color: "text.secondary", mt: 1, mb: 1 }}
          >
            Projects Assigned: {assignedProjects.length}
          </Typography>

          {/* Assigned Projects List */}
          <List className="project-list">
            {assignedProjects.map((proj, index) => (
              <Box
                key={index}
                sx={{
                  borderBottom: "1px solid #ddd",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 0,
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", my: 0.5 }}>
                  {/* Left Side - Project Details */}
                  {/* Primary Project Name */}
                  <ListItemText
                    sx={{ m: 0 }}
                    primary={proj}
                    primaryTypographyProps={{
                      sx: { fontWeight: "bolder", fontSize: "0.8rem" },
                    }}
                  />

                  <Box sx={{ display: "flex", gap: "0.5rem" }}>
                    {/* Secondary Details */}
                    <ListItemText
                      sx={{ m: 0 }}
                      primary="Country: UK"
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: "bold",
                          fontSize: "0.75rem",
                          color: "text.secondary",
                          m: 0,
                        },
                      }}
                    />
                    <ListItemText
                      sx={{ m: 0 }}
                      primary="Partner Name: NTR"
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: "bold",
                          fontSize: "0.75rem",
                          color: "text.secondary",
                          m: 0,
                        },
                      }}
                    />
                    <ListItemText
                      sx={{ m: 0 }}
                      primary="Project Name: Radcliffe"
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: "bold",
                          fontSize: "0.75rem",
                          color: "text.secondary",
                          m: 0,
                        },
                      }}
                    />
                  </Box>
                </Box>

                {/* Right Side - Unassign Button */}
                <Button
                  variant="contained"
                  color="error"
                  sx={{
                    borderRadius: "8px",
                    fontSize: "0.85rem",
                    height: "35px",
                  }}
                >
                  Unassign
                </Button>
              </Box>
            ))}
          </List>
          {isAssigning && (
            <>
              <TextField
                size="small"
                label="Search Project"
                variant="filled"
                fullWidth
                className="search-input"
                onChange={handleUserProjectSearch}
                onFocus={() => setShowUsersProjects(true)}
                onBlur={() =>
                  setTimeout(() => setShowUsersProjects(false), 200)
                }
                sx={{ my: 2, borderRadius: "8px", backgroundColor: "#f5f5f5" }}
              />
              {showUserProjects && (
                <List className="project-list">
                  {assignedProjects.map((proj, index) => (
                    <ListItem
                      button
                      key={index}
                      sx={{
                        borderBottom: "1px solid #ddd",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        py: 0,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          my: 0.5,
                        }}
                      >
                        {/* Left Side - Project Details */}
                        {/* Primary Project Name */}
                        <ListItemText
                          sx={{ m: 0 }}
                          primary={proj}
                          primaryTypographyProps={{
                            sx: { fontWeight: "bolder", fontSize: "0.8rem" },
                          }}
                        />

                        <Box sx={{ display: "flex", gap: "0.5rem" }}>
                          {/* Secondary Details */}
                          <ListItemText
                            sx={{ m: 0 }}
                            primary="Country: UK"
                            primaryTypographyProps={{
                              sx: {
                                fontWeight: "bold",
                                fontSize: "0.75rem",
                                color: "text.secondary",
                                m: 0,
                              },
                            }}
                          />
                          <ListItemText
                            sx={{ m: 0 }}
                            primary="Partner Name: NTR"
                            primaryTypographyProps={{
                              sx: {
                                fontWeight: "bold",
                                fontSize: "0.75rem",
                                color: "text.secondary",
                                m: 0,
                              },
                            }}
                          />
                          <ListItemText
                            sx={{ m: 0 }}
                            primary="Project Name: Radcliffe"
                            primaryTypographyProps={{
                              sx: {
                                fontWeight: "bold",
                                fontSize: "0.85rem",
                                color: "text.secondary",
                                m: 0,
                              },
                            }}
                          />
                        </Box>
                      </Box>

                      {/* Right Side - Unassign Button */}
                      <Button
                        variant="contained"
                        color="primary"
                        sx={{
                          borderRadius: "8px",
                          fontSize: "0.85rem",
                          height: "35px",
                        }}
                      >
                        Assign
                      </Button>
                    </ListItem>
                  ))}
                </List>
              )}
            </>
          )}

          {/* Assign Project Button */}
          {!showUserProjects && (
            <Button
              variant="contained"
              color="primary"
              fullWidth
              className="assign-btn"
              sx={{
                borderRadius: "8px",
                fontSize: "1rem",
                fontWeight: "bold",
                py: 1,
              }}
              onClick={() => setIsAssigning(!isAssigning)}
            >
              Assign Project
            </Button>
          )}

          {/* Search Input for Assigning Project */}
        </>
      )}
    </Box>
  );
};

const ProjectSection2 = ({ title, searchPlaceholder }) => {
  const [searchValue, setSearchValue] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [filteredProjects, setFilteredProjects] = useState([]);
  const [assignedProjects, setAssignedProjects] = useState([
    "sidhantnahak2@gmail.com",
    "rakeshnahak@gmail.com",
    "laxminahak@gmail.com",
  ]);
  const [isAssigning, setIsAssigning] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const allUsers = ["Project A", "Project B"];
  // const allUsers = ["User 1", "User 2", "User 3"];
  const allProjects = ["Project C", "Project D", "Project E"];
  const [UserProjects, setUserProjects] = useState(["Project A", "Project B"]);

  const handleUserSelect = (user) => {
    setSelectedUser(user);
    setSearchValue("");
  };

  const handleProjectSearch = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    setFilteredProjects(
      allProjects.filter((proj) =>
        proj.toLowerCase().includes(value.toLowerCase())
      )
    );
  };

  const handleUserProjectSearch = (proj) => {
    setSelectedUser(proj);
    // const value = e.target.value;
    // setUserProjects(
    //   UserProjects.filter((proj) =>
    //     proj.toLowerCase().includes(value.toLowerCase())
    //   )
    // );
  };
  return (
    <Box className="access-section">
      <Typography variant="h7" fontWeight={"bold"} className="section-title">
        {title}
      </Typography>
      <TextField
        label={searchPlaceholder}
        variant="filled"
        size="small"
        fullWidth
        className="search-input"
        value={searchValue}
        onChange={handleProjectSearch}
        onFocus={() => setShowUsers(true)}
        onBlur={() => setTimeout(() => setShowUsers(false), 200)}
        sx={{ my: 1 }}
      />

      {showUsers && (
        <List className="project-list">
          {allUsers.map((proj, index) => (
            <ListItem
              button
              key={index}
              sx={{
                borderBottom: "1px solid #ddd",
                display: "flex",
                alignItems: "center",
                p: "0.5vmin 1.5vmin",
              }}
              onClick={() => handleUserProjectSearch(proj)}
            >
              <Box sx={{ display: "flex", flexDirection: "column", my: 0.5 }}>
                {/* Left Side - Project Details */}
                {/* Primary Project Name */}
                <ListItemText
                  sx={{ m: 0 }}
                  primary={proj}
                  primaryTypographyProps={{
                    sx: { fontWeight: "bolder", fontSize: "0.8rem" },
                  }}
                />

                <Box sx={{ display: "flex", gap: "0.5rem" }}>
                  {/* Secondary Details */}
                  <ListItemText
                    sx={{ m: 0 }}
                    primary="Country: UK"
                    primaryTypographyProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "0.75rem",
                        color: "text.secondary",
                        m: 0,
                      },
                    }}
                  />
                  <ListItemText
                    sx={{ m: 0 }}
                    primary="Partner Name: NTR"
                    primaryTypographyProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "0.75rem",
                        color: "text.secondary",
                        m: 0,
                      },
                    }}
                  />
                  <ListItemText
                    sx={{ m: 0 }}
                    primary="Project Name: Radcliffe"
                    primaryTypographyProps={{
                      sx: {
                        fontWeight: "bold",
                        fontSize: "0.75rem",
                        color: "text.secondary",
                        m: 0,
                      },
                    }}
                  />
                </Box>
              </Box>
            </ListItem>
          ))}
        </List>
      )}
      {selectedUser && !showUsers && (
        <>
          {/* Selected User */}
          <Typography
            variant="h6"
            sx={{ mt: 2, fontWeight: "bold", color: "primary.main" }}
          >
            {selectedUser}
          </Typography>

          {/* Number of Projects Assigned */}
          <Typography
            variant="body1"
            sx={{ fontWeight: "bold", color: "text.secondary", mt: 1, mb: 1 }}
          >
            Users Assigned: {assignedProjects.length}
          </Typography>

          {/* Assigned Projects List */}
          <List className="project-list">
            {assignedProjects.map((proj, index) => (
              <Box
                key={index}
                sx={{
                  borderBottom: "1px solid #ddd",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 0,
                }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", my: 1 }}>
                  {/* Left Side - Project Details */}
                  {/* Primary Project Name */}
                  <ListItemText
                    sx={{ m: 0 }}
                    primary={proj}
                    primaryTypographyProps={{
                      sx: { fontWeight: "bolder", fontSize: "0.8rem" },
                    }}
                  />

                    {/* Secondary Details */}
                    <ListItemText
                      sx={{ m: 0 }}
                      primary="Assigned projects: 8"
                      primaryTypographyProps={{
                        sx: {
                          fontWeight: "bold",
                          fontSize: "0.75rem",
                          color: "text.secondary",
                          m: 0,
                        },
                      }}
                    />
                  
                </Box>

                {/* Right Side - Unassign Button */}
                <Button
                  variant="contained"
                  color="error"
                  sx={{
                    borderRadius: "8px",
                    fontSize: "0.85rem",
                    height: "35px",
                  }}
                >
                  Unassign
                </Button>
              </Box>
            ))}
          </List>
          

          {/* Assigned Projects List */}
          {showUsers && (
            <List className="user-list">
              {allUsers.map((item, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleUserSelect(item)}
                >
                  <Box>
                    {/* Primary text styling */}
                    <ListItemText
                      primary={item}
                      primaryTypographyProps={{
                        sx: { fontWeight: "bold", fontSize: "2vmin" },
                      }}
                    />

                    {/* Secondary text styling */}
                    <ListItemText
                      secondary={`Assigned Projects: ${assignedProjects.length}`}
                      secondaryTypographyProps={{
                        sx: { fontWeight: "bold", fontSize: "1.5vmin" }, // Adjust size as needed
                      }}
                    />
                  </Box>
                </ListItem>
              ))}
            </List>
          )}

          {/* Assign Project Button */}
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className="assign-btn"
            sx={{
              mt: 2,
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "bold",
              py: 1,
            }}
            onClick={() => setIsAssigning(!isAssigning)}
          >
            Assign Project
          </Button>

          {/* Search Input for Assigning Project */}
          {isAssigning && (
            <TextField
              size="small"
              label="Search Project"
              variant="outlined"
              fullWidth
              className="search-input"
              sx={{ my: 2, borderRadius: "8px", backgroundColor: "#f5f5f5" }}
              onChange={handleProjectSearch}
            />
          )}
        </>
      )}
    </Box>
  );
};

const UserManagement = () => (
  <Box className="section-container">
    <AccessSection title="Registered Users" searchPlaceholder="Search User" />
    <AccessSection title="Existing Users" searchPlaceholder="Search User" />
  </Box>
);

const AccessSection = ({ title, searchPlaceholder }) => (
  <Box className="access-section">
    <Typography variant="h6" className="section-title">
      {title}
    </Typography>
    <TextField
      label={searchPlaceholder}
      variant="outlined"
      fullWidth
      className="search-input"
      sx={{ my: 2 }}
    />
    <List className="user-list">
      {["Item 1", "Item 2", "Item 3"].map((item, index) => (
        <ListItem key={index}>
          <ListItemText primary={item} />
        </ListItem>
      ))}
    </List>
    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
      <Button variant="contained" color="error">
        Unassign
      </Button>
      <Button variant="contained" color="primary">
        Assign
      </Button>
    </Box>
  </Box>
);

export default AdminDashboard2;
